<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
  import {
    mapMutations,
    mapGetters
  } from 'vuex';
  import {
    get_ip_address
  } from '@/network/index.js';
  export default {
    computed: {
      ...mapGetters('setting', ['GET_PLATFORM'])
    },
    watch: {
      "$route.name": {
        handler: function(val, oldVal) {
          if (this.GET_PLATFORM === 'xcx') {
            return
          }
          if (val === 'productInfo' || val === 'peripheralInfo') {
            return
          }
          document.title = this.$t(`tdk.${val}`)
          document
            .querySelector('meta[name="keywords"]')
            .setAttribute("content", this.$t(`tdk.${val}`));
          document
            .querySelector('meta[name="description"]')
            .setAttribute("content", this.$t(`tdk.${val}`));
        },
        immediate: true
      },
      "$store.state.setting.lang": {
        handler: function(val, oldVal) {
          if (this.GET_PLATFORM === 'xcx') {
            return
          }
          if (val === 'productInfo' || val === 'peripheralInfo') {
            return
          }
          document.title = this.$t(`tdk.${this.$route.name}`)
          document
            .querySelector('meta[name="keywords"]')
            .setAttribute("content", this.$t(`tdk.${this.$route.name}`));
          document
            .querySelector('meta[name="description"]')
            .setAttribute("content", this.$t(`tdk.${this.$route.name}`));
        },
        deep: true
      }

    },
    created() {
      if (navigator.language) {
        if(navigator.language.toLowerCase()==='ja'){
          this.init_setlang('jp')
        }else if(navigator.language.search('zh-')===0){
          this.init_setlang('cn')
        }else{
          this.init_setlang('en')
        }
       // console.log(navigator.language)
      } else {
        get_ip_address({}).then((res) => {
          if (res.code === '0') {
            this.init_setlang(res.data)
          }
        })
      }



    },

    methods: {
      ...mapMutations('setting', ['SET_LANG']),
      //初始化语言设置
      init_setlang(lang) {
        let path = this.$route.path;
        if (lang === 'cn') { //中文
          if (path === '/login' || path === '/signUp' || path === '/reset' || path ===
            '/userCenter' || path === '/userEdit') {
            //判断当前语言
            if (localStorage.getItem('lang') === 'en') {
              this.SET_LANG('en')
            } else if (localStorage.getItem('lang') === 'ja') {
              this.SET_LANG('ja')
            } else if (localStorage.getItem('lang') === 'zh') {
              this.SET_LANG('en')
            } else {
              this.SET_LANG('en')
            } //end

          } else {
            this.SET_LANG('zh')
          } // end
          return
        };
        if (lang === 'en') { //英文
          this.SET_LANG('en')
          return
        };
        if (lang === 'jp') { //日文
          this.SET_LANG('ja')
          return
        };
        //console.log('我不该出现')
        this.SET_LANG('en')
      }, //end init_setlang
    }
  }
</script>

<style>
  #app {
    overflow-x: hidden;
  }

  .font_misans {
   font-weight: bold;
  }

  * {
    padding: 0;
    margin: 0;
    border: 0;
  }



  a {
    text-decoration: none;
  }

  .p_flex {
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
  }

  .p_flex1 {
    flex: 1;
    -ms-flex: 1;
    -webkit-flex: 1;
  }

  .p_row_reverse {
    flex-direction: row-reverse;
    -ms-flex-direction: row-reverse;
    -webkit-flex-direction: row-reverse;
  }

  .p_flex_wrap {
    -ms-flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
  }

  .p_space_between {
    justify-content: space-between;
    -webkit-justify-content: space-between;
  }

  .p_align_items {
    align-items: center;
    -webkit-align-items: center;
  }

  .p_column_between {
    align-content: space-between;
    -webkit-align-content: space-between;
  }

  .p_justify_center {
    justify-content: center;
    -webkit-justify-content: center;
  }

  .p_text_right {
    text-align: right;
  }

  .p_text_center {
    text-align: center;
  }

  .p_column {
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
  }

  .p_align_row {
    -ms-flex-direction: row;
    -webkit-flex-direction: row;
    flex-direction: row;
  }

  /* 浮动 */
  .float_left {
    float: left;
  }

  .float_right {
    float: right;
  }

  /*清除浮动*/
  .clear_float:before,
  .clear_float:after {
    content: ' ';
    display: inline-block;
    height: 0;
    clear: both;
    visibility: hidden;
  }

  .clear_float {
    zoom: 1;
  }

  /* 圆角 */
  .border_radius2 {
    border-radius: 2px;
  }

  .border_radius3 {
    border-radius: 3px;
  }

  .border_radius6 {
    border-radius: 6px;
  }

  .border_radius10 {
    border-radius: 10px;
  }

  .border_radius12 {
    border-radius: 12px;
  }

  .border_radius14 {
    border-radius: 14px;
  }

  .border_radius18 {
    border-radius: 18px;
  }

  .border_radius20 {
    border-radius: 20px;
  }

  .border_radius25 {
    border-radius: 25px;
  }

  .border_radius_round {
    border-radius: 50%;
  }

  /* 盒子阴影 */
  .p_box_shadow {
    box-shadow: 0px 0px 14px 6px rgba(77, 77, 77, 0.08);
  }

  /* 一行文本变点 */
  .p_line1_dot {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* 二行文本变点 */
  .p_line2_dot {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  /* 三行文本变点 */
  .p_line3_dot {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }

  /* 四行文本变点 */
  .p_line4_dot {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
  }

  .p_break_all {
    word-break: break-all;
  }

  .p_notext {
    user-select: none;
  }

  .p_hidden {
    display: none !important;
  }

  .p_hand {
    cursor: pointer;
    user-select: none;
    /* transition: all 1s; */
  }

  .p_no_click {
    background: #d5d5d5;
    pointer-events: none;
  }

  .p_hand:active {
    opacity: 0.8;
  }

  /* 字体加粗 */
  .font_bold {
    font-weight: bold;
  }

  .font_500 {
    font-weight: 500;
  }

  .font_600 {
    font-weight: 600;
  }

  .font_800 {
    font-weight: 800;
  }

  /* 字体大小 */
  .font_0 {
    font-size: 0;
  }

  .font_9 {
    font-size: 0.09rem;
  }

  .font_10 {
    font-size: 0.1rem;
  }

  .font_12 {
    font-size: 12px;
  }

  .font_14 {
    font-size: 14px;
  }

  .font_15 {
    font-size: 15px;
  }

  .font_16 {
    font-size: 16px;
  }

  .font_18 {
    font-size: 18px;
  }

  .font_20 {
    font-size: 20px;
  }

  .font_21 {
    font-size: 21px;
  }

  .font_24 {
    font-size: 24px;
  }

  .font_30 {
    font-size: 30px !important;
  }

  .font_36 {
    font-size: 36px;
  }

  .font_40 {
    font-size: 40px;
  }

  .font_48 {
    font-size: 48px;
  }

  .font_60 {
    font-size: 60px;
  }

  .font_72 {
    font-size: 72px;
  }

  .color_ffffff {
    color: #ffffff;
  }

  .color_000000 {
    color: #000000;
  }

  .color_040404 {
    color: #040404;
  }

  .color_DC000C {
    color: #dc000c;
  }

  .color_8F8F8F {
    color: #8f8f8f;
  }

  .color_touming {
    color: rgba(255, 255, 255, 0.5);
  }

  .bg_DC000C {
    background: #dc000c;
  }

  .bg_D5D5D5 {
    background: #d5d5d5;
  }

  .bg_ffffff {
    background: #ffffff;
  }

  .bg_000000 {
    background: #000000;
  }

  .bg_ebebeb {
    background: #ebebeb;
  }

  .bg_lucency {
    background-color: transparent;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%);
  }

  .bg_lucency2 {
    background-color: transparent;
  }

  /*  */
  .el-image-viewer__actions {
    display: none !important;
    z-index: -11 !important;
    left: 100%
  }
</style>



// WEBPACK FOOTER //
// src/App.vue